import { useMutation } from '@tanstack/react-query';
import * as z from 'zod';

import { MEMBERSHIP_GROUP_MEMBER_ACCESS_LEVEL, type MembershipGroupMember } from 'src/features/memberships/types';
import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { validationMessagesMap } from 'src/utils/messages';
import { formatResourcePath } from 'src/utils/regex';

import type { GeneralMixedError } from 'src/types';

const RESOURCE = '/parkings/:parkingId/membership-groups/:membershipGroupId/members/';

type FormSchemaValues = z.infer<typeof formSchema>;
const formSchema = z.object({
    email: z.string().email({ message: validationMessagesMap.validationErrorEmail }),
    access_level: z.nativeEnum(MEMBERSHIP_GROUP_MEMBER_ACCESS_LEVEL),
});

interface DTO extends FormSchemaValues {
    parkingId: string;
    membershipGroupId: number;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, membershipGroupId, ...data }: DTO): Promise<MembershipGroupMember> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId, membershipGroupId }), data);
};

interface UseMutationOptions extends MutationConfig<MutationFnType, GeneralMixedError<FormSchemaValues>> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export {
    RESOURCE as CREATE_MEMBERSHIP_GROUP_MEMBER_RESOURCE,
    useMutationHook as useCreateMembershipGroupMember,
    formSchema as createMembershipGroupMemberFormSchema,
};
export type { DTO as CreateMembershipGroupMemberDTO, FormSchemaValues as CreateMembershipGroupMemberFormSchemaValues };
